import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services';

@Component({
  selector: 'kt-app-forgot-password',
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);

  error: string | null = null;

  forgotPasswordForm: FormGroup = this.fb.group(
    {
      email: ['', [Validators.required, Validators.email]]
    }
  )

  onSubmit(): void{
    if(this.forgotPasswordForm.invalid){
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    const { email } = this.forgotPasswordForm.value;

    this.authService.triggerForgotPassword(email!).subscribe({
      next:(res) =>{
        if(res){
          this.router.navigateByUrl('/auth/login');
        }
      },
      error: (err) =>{
        this.error = err?.error?.message || 'Unable to trigger forgot password. Please try again';
      }
    })
  }
}
